<template>
  <v-dialog v-model="dialogResendEmail" max-width="700px" scrollable>
    <v-card>
      <v-col class="px-6">
        <span style="font-weight: bold; font-size: 20px">
          {{ $t('sales.affiliates_program_email_resend') }}
        </span>
        <v-alert
          class="mb-3 mt-3"
          border="left"
          colored-border
          type="info"
          elevation="2"
        >
          {{ $t('sales.affiliates_program_email_resend_info') }}
        </v-alert>
      </v-col>
      <v-card-text class="d-flex justify-center align-center">
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              :label="$t('sales.affiliates_program_resend_field')"
              :placeholder="$t('sales.affiliates_program_resend_field_placeholder')"
              item-text="nome"
              return-object
              small-chips
              solo
              dense
              multiple
              item-color="tertiary"
              :clearable="false"
              :items="affiliatesToResendEmail"
              v-model="selectedAffiliates"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="$config.dados.primary"
          @click="closeModal"
          class="rounded-xxl"
          outlined
          >{{ $t('sales.affiliates_program_cancel') }}</v-btn
        >
        <v-btn
          @click="handleSave"
          :color="$config.dados.primary"
          class="rounded-xxl"
          style="color: white"
          >{{ $t('sales.affiliates_program_save') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "DialogResendEmailAffiliate",
  data() {
    return {
      selectedAffiliates: [],
    };
  },
  computed: {
    ...mapGetters([
      "dialogResendEmail",
      "affiliatesToResendEmail",
      "tmpIdToResendEmail",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchAllAffiliates",
      "cleanStates",
      "showSnackbarSuccess",
      "changeDialogResendEmail",
      "resendEmail",
      "getInfoProgram",
    ]),

    closeModal() {
      this.selectedAffiliates = [];
      this.changeDialogResendEmail(this.tmpIdToResendEmail);
    },
    handleSave() {
      this.resendEmail({
        idprograma: this.tmpIdToResendEmail,
        idafiliado: this.selectedAffiliates,
      });
      this.closeModal();
    },
    getInfo() {
      this.getInfoProgram({ id: this.tmpIdToResendEmail });
    },
  },
  watch: {
    tmpIdToResendEmail() {
      if (this.dialogInsertAffiliate) {
        this.getInfo();
      } else {
        this.cleanStates();
      }
    },
  },
};
</script>
